import { render, staticRenderFns } from "./createTeam.vue?vue&type=template&id=51abd29c&scoped=true"
import script from "./createTeam.vue?vue&type=script&lang=js"
export * from "./createTeam.vue?vue&type=script&lang=js"
import style0 from "./createTeam.vue?vue&type=style&index=0&id=51abd29c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51abd29c",
  null
  
)

export default component.exports